import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
      redirectTo: 'clave',
      pathMatch: 'full'
  },
  {
      path: 'clave',
      loadChildren: () => import('./clave/clave.module').then( m => m.ClaveModule),
  },
  {
      path: 'home',
      loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },
  {
      path: 'bienvenida',
      loadChildren: () => import('./bienvenida/bienvenida.module').then( m => m.BienvenidaPageModule),
  },
	{
		path: 'asignada',
		loadChildren: () => import('./asignada/asignada.module').then( m => m.AsignadaPageModule),
	},
	{
		path: 'regalos',
		loadChildren: () => import('./regalos/regalos.module').then( m => m.RegalosPageModule),
	},

	{
		path: 'weather',
		loadChildren: () => import('./weather/weather.module').then( m => m.WeatherPageModule)
	},

   /****************************************  NOTIFICACIONES   ************************************************ */
	{
		path: 'historiconotificaciones',
		loadChildren: () => import('./historiconotificaciones/historiconotificaciones.module').then( m => m.HistoriconotificacionesPageModule)
	},
	/****************************************  MIS ESTANCIAS   ************************************************ */
	{
		path: 'misestancias',
		loadChildren: () => import('./misestancias/misestancias.module').then( m => m.MisestanciasPageModule)
	},

	/****************************************  MIS ESTANCIAS   ************************************************ */
	{
		path: 'book',
		loadChildren: () => import('./book/book.module').then( m => m.BookPageModule)
	},


	/****************************************  LLAVE QR   ************************************************ */
	{
		path: 'llave-qr',
		loadChildren: () => import('./llave-qr/llave-qr.module').then( m => m.LlaveQrPageModule)
	},


	/****************************************  HABITACION   ************************************************ */
	{
		path: 'habitacion',
		loadChildren: () => import('./habitacion/habitacion.module').then( m => m.HabitacionPageModule)
	},

	/****************************************  ECOTEL   ************************************************ */
	{
		path: 'ecotel',
		loadChildren: () => import('./ecotel/ecotel.module').then( m => m.EcotelPageModule)
	},
	/****************************************  CUPONES   ************************************************ */
	{
		path: 'cupones',
		loadChildren: () => import('./cupones/cupones.module').then( m => m.CuponesPageModule)
	},

	/****************************************  DOMO   ************************************************ */
	{
		path: 'resume-stay',
		loadChildren: () => import('./habitacion/resume-stay/resume-stay.module').then( m => m.ResumeStayPageModule)
	},



	/****************************************  CAHT   ************************************************ */
	{
		path: 'chat',
		loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
	},

	{
		path: 'topdestinos',
		loadChildren: () => import('./home/topdestinos/topdestinos.module').then( m => m.TopdestinosPageModule)
	 },
	 {
		path: 'tepuedeinteresar',
		loadChildren: () => import('./home/tepuedeinteresar/tepuedeinteresar.module').then( m => m.TepuedeinteresarPageModule)
	 },
	 {
		path: 'ultimahora',
		loadChildren: () => import('./home/ultimahora/ultimahora.module').then( m => m.UltimahoraPageModule)
	 },
	 {
		path: 'actividades',
		loadChildren: () => import('./home/actividades/actividades.module').then( m => m.ActividadesPageModule)
	 },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
